module.exports = ".ui-dialog-footer .ui-widget-content \r\n{\r\n    height:65px !important;\r\n    border:1px solid red;\r\n    \r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/report-management/rptstatusmgmt/rptstatusmgmt.component.css
// module id = ./src/app/admin/report-management/rptstatusmgmt/rptstatusmgmt.component.css
// module chunks = main